import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'hyphen'})
export class HyphenPipe implements PipeTransform {
    transform(value: string = ''): string {
        return !value ? '' : value
            .replace(/[&@\/\\#,+()$~%.'":*?!^<>{} _]/g, '-')
            .replace(/-+/g, '-')
            .toLowerCase();
    }
}
